import React from 'react';
import * as S from './HotelCard.styles';
import PersuasionHoverText from '../PersuasionHoverText/PersuasionHoverText';
import BedIcon from '../../../../Icons/BedIcon';
import AmenitiesList from '../AmenitiesList/AmenitiesList';

import IconSelector from '@ibibo/icon-selector';

const HotelCardPersuasionsBlock = ({
  aboveRatePlanPersuasion = [],
  navigateToDetailsPage,
  roomTypeName,
  amenitiesIndexApplicableForHotel = [],
  amenitiesListMapping,
  contentPersuasion1 = [],
  contentPersuasion2 = [],
  roomTypeStyles = {},
  safety= []
}) => {
  return (
    <S.PersuasionWrapperDiv>
      {(aboveRatePlanPersuasion && aboveRatePlanPersuasion.length > 0 && (
        <S.RoomTypeWrapperDiv>
          <PersuasionHoverText
            data={aboveRatePlanPersuasion}
            actionHandler={(item, text) => {
              item.utag[0].n = text;
              navigateToDetailsPage(item);
            }}
            direction="top"
            type="aboveRatePlanPersuasion"
            hasMainTextIcon
          />
        </S.RoomTypeWrapperDiv>
      )) ||
        null}

      {/* {(roomTypeName && (
        <S.RoomTypeWrapperDiv>
          <S.RoomTypeIconWrapperSpan>
            <BedIcon />
          </S.RoomTypeIconWrapperSpan>
          <S.RoomTypeTextWrapper title={roomTypeName} {...roomTypeStyles}>
            {roomTypeName}
          </S.RoomTypeTextWrapper>
        </S.RoomTypeWrapperDiv>
      )) ||
        null} */}

      {/* {(contentPersuasion1 && contentPersuasion1.length > 0 && (
         <S.PersuationTagBlock>
          {contentPersuasion1.map((item) => {
            return(
              <S.PersuationTagNew>{item.pt}</S.PersuationTagNew>
            )
          })}
        </S.PersuationTagBlock>
      )) ||
        null} */}

      {(safety.length && 
        <S.MySafetyWrap>
          <IconSelector iconKey='mysafety' />
          <S.MySafetyTooltip>
            <S.MySafetyHeadText>This hotel has adopted the best safety standards</S.MySafetyHeadText>
            <S.MySafetyInfoList>
              {(safety[0].htd.ht.map((item, i) => <li key={`safety${i}`}>
                <IconSelector iconKey="whitetick" props={{width:'0.8rem', height:'0.8rem', margin:'0 .5rem 0 0'}}/>
                {item}
              </li>))}
            </S.MySafetyInfoList>
          </S.MySafetyTooltip>
        </S.MySafetyWrap>
        ) || null}

      {(amenitiesIndexApplicableForHotel && amenitiesIndexApplicableForHotel.length > 0 && (
        <S.AmenitiesWrapper>
          <AmenitiesList
            list={amenitiesIndexApplicableForHotel.map(item => amenitiesListMapping[item])}
          />
        </S.AmenitiesWrapper>
      )) ||
        null}

      {/* {(contentPersuasion1 && contentPersuasion1.length > 0 && (
        <S.RoomTypeWrapperDivNew>
          <PersuasionHoverText
            data={contentPersuasion1}
            direction="top"
            actionHandler={item => {
              navigateToDetailsPage(item);
            }}
            type="contentPersuasion1"
            hasMainTextIcon
          />
        </S.RoomTypeWrapperDivNew>
      )) ||
        null} */}

      {/* {(contentPersuasion2 && contentPersuasion2.length > 0 && (
        <S.RoomTypeWrapperDiv>
          <PersuasionHoverText
            data={contentPersuasion2}
            direction="top"
            actionHandler={item => {
              navigateToDetailsPage(item);
            }}
            type="contentPersuasion2"
            hasMainTextIcon
          />
        </S.RoomTypeWrapperDiv>
      )) ||
        null} */}
    </S.PersuasionWrapperDiv>
  );
};

export default HotelCardPersuasionsBlock;
